/**
 * Mapa liviano de "acá estás": embed de OpenStreetMap con un marcador.
 * Sin dependencias ni API key. Pensado para mostrar la ubicación desde donde
 * el técnico inicia la mantención.
 */
const MapaUbicacion = ({ lat, lng, delta = 0.003 }) => {
  if (lat == null || lng == null) return null;
  const bbox = [lng - delta, lat - delta, lng + delta, lat + delta].join('%2C');
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lng}`;
  return (
    <iframe
      title="Tu ubicación"
      src={src}
      style={{ width: '100%', height: 220, border: 0, borderRadius: 8 }}
      loading="lazy"
    />
  );
};

export default MapaUbicacion;
